/* JustSmoke.Me freebies - 2026-10-04 (DEV theme 189218128253)
 * Free stickers (max 5, never counted towards the threshold) + automatic Free Gift Bundle at GBP 10.00 qualifying merchandise.
 * Config comes from snippets/js-freebies-config.liquid (window.JSFREEBIES); delivery-profile lookup from assets/js-freebies-groups.js (window.JSFB_GROUPS).
 * No config / products missing => this file does nothing.
 * Postage: freebies are GBP 0 / 0 g and live in the SAME delivery profile as a real item in the cart (one variant per profile), so they never add a shipment or a charge.
 * A sticker-only cart uses the General profile and pays that profile's normal rate.
 * Honest limit: this is storefront (theme) logic. A customer who builds a cart URL by hand and goes straight to checkout can bypass it;
 * a Shopify Function / app is the only server-side enforcement. The cart page re-checks on load and before the checkout button posts.
 */
(function () {
  'use strict';
  var C = window.JSFREEBIES;
  if (!C || !C.sticker || !C.bundle || !C.sticker.variants || !C.bundle.variants) return;
  /* One sticker variant + one bundle variant per delivery profile (g = General, az = Amazon Drop-Ship, ll = Large letter),
     all GBP 0 and 0 g, so a freebie always ships in the same shipment as a real item and adds no postage. */
  var GROUPS = ['g', 'az', 'll'], SV = {}, BV = {}, SALL = {}, BALL = {};
  GROUPS.forEach(function (k) { SV[k] = Number(C.sticker.variants[k]); BV[k] = Number(C.bundle.variants[k]); SALL[SV[k]] = 1; BALL[BV[k]] = 1; });
  function dec(s) { var p = 0, o = {}; if (!s) return o; s.split(',').forEach(function (t) { p += parseInt(t, 36); o[p] = 1; }); return o; }
  var G = window.JSFB_GROUPS || {}, LL = dec(G.ll), AZ = dec(G.az);
  function groupOf(id) { return LL[id] ? 'll' : (AZ[id] ? 'az' : 'g'); }
  var MAX = Number(C.max) || 5, THRESH = Number(C.threshold) || 1000;
  var busy = false, timer = null, lastCart = null;
  var isCartPage = /\/cart\/?$/.test(location.pathname) || (document.body && document.body.classList.contains('pagecart'));

  /* freebie product pages are not meant to be browsed */
  if (/^\/products\/(free-justsmoke-stickers|free-gift-bundle)\/?$/.test(location.pathname)) { location.replace('/cart'); return; }

  function money(c) { return '£' + (c / 100).toFixed(2); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body), credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function analyse(cart) {
    var o = { merch: 0, sticker: 0, bundle: 0, cnt: { g: 0, az: 0, ll: 0 }, q: {} };
    (cart.items || []).forEach(function (it) {
      var id = it.variant_id;
      if (SALL[id]) { o.sticker += it.quantity; o.q[id] = (o.q[id] || 0) + it.quantity; }
      else if (BALL[id]) { o.bundle += it.quantity; o.q[id] = (o.q[id] || 0) + it.quantity; }
      else { o.merch += (typeof it.final_line_price === 'number' ? it.final_line_price : it.line_price); o.cnt[groupOf(id)] += it.quantity; }
    });
    /* freebies ride with a real item's delivery profile (General preferred; a sticker-only cart uses General) */
    o.group = (o.cnt.g > 0 || (o.cnt.az === 0 && o.cnt.ll === 0)) ? 'g' : (o.cnt.ll > 0 ? 'll' : 'az');
    return o;
  }

  /* cart/update.js payload that puts the wanted freebies in the right profile variant (null = already correct) */
  function plan(a, stickers) {
    var want = {}, upd = {}, need = false;
    GROUPS.forEach(function (k) { want[SV[k]] = k === a.group ? stickers : 0; want[BV[k]] = k === a.group ? (a.merch >= THRESH ? 1 : 0) : 0; });
    Object.keys(want).forEach(function (id) { if ((a.q[id] || 0) !== want[id]) { upd[id] = want[id]; need = true; } });
    return need ? upd : null;
  }

  /* Make the cart match the rules. Returns the (possibly updated) cart. */
  function reconcile() {
    if (busy) return Promise.resolve(lastCart);
    busy = true;
    return getCart().then(function (cart) {
      var a = analyse(cart), upd = plan(a, Math.min(a.sticker, MAX));
      if (!upd) { lastCart = cart; return cart; }
      return post('/cart/update.js', { updates: upd }).then(function (c2) {
        lastCart = c2.items ? c2 : cart;
        document.dispatchEvent(new CustomEvent('jsfreebies:changed', { detail: lastCart }));
        return lastCart;
      });
    }).catch(function () { return lastCart; }).then(function (c) { busy = false; return c; });
  }

  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      reconcile().then(function (cart) { if (isCartPage && cart) afterCartPageChange(cart); updateBadge(cart); });
    }, ms || 350);
  }

  /* watch cart mutations from anywhere (theme jQuery ajax, fetch, forms) */
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('loadend', function () {
      var u = this.responseURL || '';
      if (/\/cart\/(add|change|update|clear)/.test(u)) schedule(450);
    });
    return origSend.apply(this, arguments);
  };
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(u) && !busy) p.then(function () { schedule(450); }).catch(function () {});
      return p;
    };
  }

  function updateBadge(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    var els = document.querySelectorAll('.tt-cart .tt-badge-cart, .tt-obj-cart .tt-badge-cart, .tt-badge-cart');
    for (var i = 0; i < els.length; i++) els[i].textContent = cart.item_count;
  }

  /* ---------------- cart page UI ---------------- */
  var SVG_STICKER = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><rect width="120" height="120" rx="18" fill="#ffd200"/><path d="M60 14l13 28 31 4-23 21 6 30-27-15-27 15 6-30-23-21 31-4z" fill="#e63946" stroke="#111" stroke-width="5" stroke-linejoin="round"/></svg>');
  var SVG_GIFT = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><rect width="120" height="120" rx="18" fill="#1e6bff"/><rect x="22" y="48" width="76" height="52" rx="6" fill="#ffd200" stroke="#111" stroke-width="5"/><rect x="16" y="36" width="88" height="18" rx="6" fill="#e63946" stroke="#111" stroke-width="5"/><path d="M60 36v64" stroke="#111" stroke-width="5"/><path d="M60 36c-6-18-26-18-22-6 3 8 22 6 22 6zM60 36c6-18 26-18 22-6-3 8-22 6-22 6z" fill="#fff" stroke="#111" stroke-width="5" stroke-linejoin="round"/></svg>');

  function afterCartPageChange() {
    /* reload keeps theme totals / rows / shipping box perfectly in sync; remember scroll */
    var last = Number(sessionStorage.getItem('jsfb_rl') || 0);
    if (Date.now() - last < 1500) return;
    try { sessionStorage.setItem('jsfb_rl', String(Date.now())); sessionStorage.setItem('jsfb_y', String(window.scrollY)); } catch (e) {}
    location.reload();
  }

  function lockRows() {
    var rows = document.querySelectorAll('.tt-shopcart-table-02 tr, .tt-shopcart-table tr');
    for (var i = 0; i < rows.length; i++) {
      var tr = rows[i], a = tr.querySelector('a[href*="/products/"]');
      if (!a) continue;
      var h = a.getAttribute('href') || '', kind = '';
      if (h.indexOf('/products/' + C.sticker.handle) > -1) kind = 'sticker';
      else if (h.indexOf('/products/' + C.bundle.handle) > -1) kind = 'bundle';
      if (!kind) continue;
      tr.classList.add('jsfb-row', 'jsfb-row--' + kind);
      var img = tr.querySelector('.tt-product-img img');
      var src = img ? (img.getAttribute('src') || '') : '';
      if (img && (!src || /no-image|no_image|placeholder/i.test(src))) { img.removeAttribute('srcset'); img.src = kind === 'sticker' ? SVG_STICKER : SVG_GIFT; }
      var qi = tr.querySelector('input[name="updates[]"]'), qc = tr.querySelector('.detach-quantity-desctope');
      if (qi && qc && !qc.querySelector('.jsfb-qlabel')) { var ql = document.createElement('span'); ql.className = 'jsfb-qlabel'; ql.textContent = '× ' + qi.value; qc.appendChild(ql); }
      var link = tr.querySelector('h2.tt-title a');
      if (link) { link.removeAttribute('href'); link.style.pointerEvents = 'none'; }
      var tag = document.createElement('span');
      tag.className = 'jsfb-tag';
      tag.textContent = kind === 'sticker' ? 'FREE • change in the sticker box' : 'FREE GIFT • added automatically';
      var h2 = tr.querySelector('h2.tt-title');
      if (h2 && !h2.querySelector('.jsfb-tag')) h2.appendChild(tag);
    }
  }

  function buildPanel(cart) {
    var a = analyse(cart), left = Math.max(0, THRESH - a.merch), pct = Math.min(100, Math.round(a.merch / THRESH * 100));
    var unlocked = a.merch >= THRESH;
    var box = document.createElement('div');
    box.className = 'container-indent jsfb-wrap';
    box.innerHTML =
      '<div class="container"><div class="jsfb-grid">' +
      '<section class="jsfb-card jsfb-card--stickers" aria-label="Free stickers">' +
        '<img class="jsfb-art" alt="" width="64" height="64" src="' + SVG_STICKER + '">' +
        '<div class="jsfb-body"><h2 class="jsfb-title">FREE STICKERS <span class="jsfb-pill">£0.00</span></h2>' +
        '<p class="jsfb-text">Grab up to <strong>' + MAX + '</strong> free JustSmoke.Me stickers. Postage is included in your order’s normal shipping.</p>' +
        '<div class="jsfb-step" role="group" aria-label="Free sticker quantity">' +
          '<button type="button" class="jsfb-btn jsfb-minus" aria-label="Fewer stickers">−</button>' +
          '<output class="jsfb-qty" aria-live="polite">' + Math.min(a.sticker, MAX) + '</output>' +
          '<button type="button" class="jsfb-btn jsfb-plus" aria-label="More stickers">+</button>' +
          '<span class="jsfb-max">of ' + MAX + ' max</span></div>' +
        '<p class="jsfb-fine">Stickers don’t count towards the £10 Free Gift Bundle.</p></div>' +
      '</section>' +
      '<section class="jsfb-card jsfb-card--gift' + (unlocked ? ' is-unlocked' : '') + '" aria-label="Free gift bundle">' +
        '<img class="jsfb-art" alt="" width="64" height="64" src="' + SVG_GIFT + '">' +
        '<div class="jsfb-body"><h2 class="jsfb-title">FREE GIFT BUNDLE <span class="jsfb-pill">£0.00</span></h2>' +
        '<p class="jsfb-text">' + (unlocked ? '<strong>Unlocked!</strong> A bundle of random goodies is in your parcel.' : 'Spend <strong>' + money(left) + '</strong> more on products to unlock a bundle of random goodies.') + '</p>' +
        '<div class="jsfb-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>' +
        '<p class="jsfb-fine">£10.00 of products (stickers and the gift itself don’t count).</p></div>' +
      '</section></div></div>';
    return box;
  }

  function initCartPage(cart) {
    var anchor = document.querySelector('.tt-empty-cart-js') || document.querySelector('.line-items-box-js');
    if (!anchor || document.querySelector('.jsfb-wrap')) return;
    var panel = buildPanel(cart);
    anchor.parentNode.insertBefore(panel, anchor);
    var qtyEl = panel.querySelector('.jsfb-qty'), cur = Number(qtyEl.textContent), t2 = null;
    function set(n) {
      n = Math.max(0, Math.min(MAX, n)); cur = n; qtyEl.textContent = n;
      clearTimeout(t2);
      t2 = setTimeout(function () {
        getCart().then(function (c0) {
          var u = plan(analyse(c0), n);
          return u ? post('/cart/update.js', { updates: u }) : null;
        }).then(function () {
          return reconcile();
        }).then(function () { try { sessionStorage.setItem('jsfb_rl', '0'); sessionStorage.setItem('jsfb_y', String(window.scrollY)); } catch (e) {} location.reload(); });
      }, 600);
    }
    panel.querySelector('.jsfb-minus').addEventListener('click', function () { set(cur - 1); });
    panel.querySelector('.jsfb-plus').addEventListener('click', function () { set(cur + 1); });
    /* never let the checkout button post an out-of-rule cart */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[name=checkout]');
      if (!b || b.dataset.jsfbOk === '1') return;
      e.preventDefault(); e.stopPropagation();
      reconcile().then(function (c2) {
        var a2 = analyse(c2 || cart);
        b.dataset.jsfbOk = '1';
        if (a2.bundle !== (a2.merch >= THRESH ? 1 : 0)) { location.reload(); return; }
        b.click();
      });
    }, true);
    lockRows();
    var y = Number(sessionStorage.getItem('jsfb_y') || 0);
    if (y) { try { sessionStorage.removeItem('jsfb_y'); } catch (e) {} setTimeout(function () { window.scrollTo(0, y); }, 60); }
  }

  function boot() {
    var hasCartCookie = document.cookie.indexOf('cart=') > -1;
    if (!isCartPage && !hasCartCookie) return;
    reconcile().then(function (cart) {
      if (!cart) return;
      updateBadge(cart);
      if (isCartPage) {
        var a = analyse(cart);
        /* reconcile may have changed the cart after the page was rendered: reload once so rows/totals match */
        initCartPage(cart);
        var domBundle = !!document.querySelector('.jsfb-row--bundle');
        if (domBundle !== (a.bundle > 0)) afterCartPageChange(cart);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
